<template src="./tabellaFaturato.html"></template>



<script>
import tabella from "@/components/statistiche/VTable";
import { get_statisticheSerie } from "@/api/api.statistiche.js";

export default {
  props: {
    item: { type: Object, default: null },
    confrontoDate: { type: Boolean, default: false },
    filtroTipologia: { type: String, default: "" },
    annoSel: { type: Number, default: 0 },
    userSwitch: { type: Object, default: null },
    role: { type: String, default: "" },
    refresh: { type: Boolean, default: false },
    dataDa: { type: String, default: "" },
    dataA: { type: String, default: "" },
    dataDa2: { type: String, default: "" },
    dataA2: { type: String, default: "" },
    tipoFiltroSel: { type: Number, default: 0 },
    attestaConfronto: { type: Boolean, default: false },
  },

  components: {
    tabella,
  },
  data: () => ({
    dati: [],
    datiC: [],
  }),

  methods: {
    async caricaDati() {
      if (this.userSwitch == null || this.role == "") {
        return;
      }
      this.dati = [];
      if (this.confrontoDate) {
        await this.getStatisticheConfronto();
        return;
      }
      this.attesa = true;
      let par = "";
      par = this.anno + "-01-01" + "/" + this.anno + "-12-31" + "/";

      par += this.getFiltroConfermati();
      par += "/F";
      if (this.userSwitch.Codice)
        par += "/" + this.userSwitch.Tipo + "/" + this.userSwitch.Codice;
      else if (
        this.role == "Cliente" ||
        this.role == "Agente" ||
        this.role == "AgenteCapo"
      )
        par += "/" + this.role + "/" + this.userSwitch.Codice;

      let res = await get_statisticheSerie(par);
      this.dati = res.data.DatiTabella;
      this.attesa = false;

      this.$emit("caricaAltriDati", this.dati, null, res.data.DatiExcel, null);
    },

    getFiltroConfermati() {
      if (this.tipoFiltroSel == 0) return "/1";
      // confermati
      else if (this.tipoFiltroSel == 1) return "/3";
      // consegnati
      else return "/0"; //da confermare
    },

    async getStatisticheConfronto() {
      this.attesa = true;
      if (this.dataDa == "" || this.dataA == "") return;
      let par =
        this.dataDa + "/" + this.dataA + "/" + this.getFiltroConfermati();
      par += "/F";
      let par2 =
        this.dataDa2 + "/" + this.dataA2 + "/" + this.getFiltroConfermati();
      par2 += "/F";
      if (this.userSwitch.Codice) {
        par += "/" + this.userSwitch.Tipo + "/" + this.userSwitch.Codice + "/";
        par2 += "/" + this.userSwitch.Tipo + "/" + this.userSwitch.Codice + "/";
      }
      this.dati = [];
      this.datiC = [];

      let res = await get_statisticheSerie(par);
      let res2 = await get_statisticheSerie(par2);
      this.dati = res.data.DatiTabella;
      this.datiC = res2.data.DatiTabella;
      this.attesa = false;

      this.$emit(
        "caricaAltriDati",
        this.dati,
        this.datiC,
        res.data.DatiExcel,
        res2.data.DatiExcel
      );
    },

    getSomma(tipo) {
      let res = 0;
      let arrFilter = this.dati;
      arrFilter = arrFilter.filter((x) => x.Filtro == this.filtroTipologia);
      if (tipo) {
        arrFilter = arrFilter.filter((x) => x.Tipologia == tipo);
      }

      arrFilter.forEach((value) => {
        // Ciclo sulle chiavi del json
        for (var key in value) {
          // Escludo colonna
          if (value[key] == -1) continue;
          // Escludo colonna
          if (
            key == "Tipologia" ||
            key == "Filtro" ||
            key == "Anno" ||
            key == "Periodo"
          )
            continue;
          res += value[key];
        }
      });

      return (
        res.toLocaleString() +
        (this.filtroTipologia == "Fatturato" ? " € " : "")
      );
    },

    getSommaC(tipo) {
      let res = 0;
      let arrFilter = this.datiC;
      arrFilter = arrFilter.filter((x) => x.Filtro == this.filtroTipologia);
      if (tipo) {
        arrFilter = arrFilter.filter((x) => x.Tipologia == tipo);
      }

      arrFilter.forEach((value) => {
        // Ciclo sulle chiavi del json
        for (var key in value) {
          // Escludo colonna
          if (value[key] == -1) continue;
          // Escludo colonna
          if (
            key == "Tipologia" ||
            key == "Filtro" ||
            key == "Anno" ||
            key == "Periodo"
          )
            continue;
          res += value[key];
        }
      });

      return (
        res.toLocaleString() +
        (this.filtroTipologia == "Fatturato" ? " € " : "")
      );
    },

    getDati(tipo) {
      let arr = this.dati.filter(
        (x) => x.Tipologia == tipo && x.Filtro == this.filtroTipologia
      );
      //se ho il confronto date ritorno i dati di entrambi i periodi
      if (this.confrontoDate) {
        let temp = this.datiC.filter(
          (x) => x.Tipologia == tipo && x.Filtro == this.filtroTipologia
        );
        if (temp != null && temp.length > 0 && temp[0] != undefined) {
          arr.push({});
          arr[1] = temp[0];
        }
      }
      return arr;
    },

    getStyle(component) {
      switch (component) {
        case "card":
          if (this.isSmartphone) {
            return {
              "min-width": "100%",
              "max-height": "150px !important",
              "min-height": "150px !important",
            };
          }
          if (this.confrontoDate)
            return {
              "max-width": "100%!important",
              "min-width": "150px!important",
              "min-height": "130px !important",
            };
          else
            return {
              "max-width": "100%!important",
              "min-width": "135px!important",
              "min-height": "260px!important",
            };

        case "card-div":
          if (this.confrontoDate)
            return {
              "background-color": "#f2f2f2",
              color: "black",
              "min-height": "150px !important",
            };
          else
            return {
              "background-color": "#EE1453",
              "min-height": "260px !important",
            };

        case "cardConfronto":
          if (this.confrontoDate)
            return {
              "max-width": "100%!important",
              "min-width": "150px!important",
              "min-height": "130px !important",
            };
          else
            return {
              "max-width": "100%!important",
              "min-width": "135px!important",
              "min-height": "260px!important",
            };
        default:
          break;
      }
    },
  },
  mounted() {
    //this.caricaDati();
  },

  watch: {
    userSwitch(val) {
      this.caricaDati();
    },

    refresh(val) {
      this.caricaDati();
    },

    attestaConfronto(val) {
      if (val) {
        this.dati = [];
        this.datiC = [];
      }
    },
  },
  computed: {
    anno() {
      return this.annoSel == 0 ? this.$i2kFunctions.getYear() : this.annoSel;
    },

    isSmartphone: function () {
      return this.$i2kFunctions.isSmartphone();
    },
  },
};
</script>